import React, { useContext, createContext, useReducer, useEffect } from 'react';

import { getConsent, setConsent, defaultConsent } from '~/utilities/consent';
import { loadGTM } from '~/utilities/gtm';

const ConsentContext = createContext();

const HYDRATE = 'HYDRATE';
const OPT_IN = 'OPT_IN';
const OPT_OUT = 'OPT_OUT';
const OPEN_SETTINGS = 'OPEN_SETTINGS';
const CLOSE_SETTINGS = 'CLOSE_SETTINGS';

const initialState = {
    ...defaultConsent,
    showBanner: false,
    hydrated: false
};

const reducer = (state, action) => {
    switch (action.type) {
        case HYDRATE:
            return {
                ...state,
                decision: action.decision,
                marketing: action.marketing,
                showBanner: !action.decision,
                hydrated: true
            };
        case OPT_IN:
            return {
                ...state,
                decision: true,
                marketing: true,
                showBanner: false
            };
        case OPT_OUT:
            return {
                ...state,
                decision: true,
                marketing: false,
                showBanner: false
            };
        case OPEN_SETTINGS:
            return {
                ...state,
                showBanner: true
            };
        case CLOSE_SETTINGS:
            return {
                ...state,
                showBanner: false
            };
        default:
            return state;
    }
};

export const ConsentProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        const { decision, marketing } = getConsent();
        dispatch({ type: HYDRATE, decision, marketing });
    }, []);

    const optIn = () => {
        setConsent({ decision: true, marketing: true });
        loadGTM(process.env.GATSBY_GOOGLE_TAG_MANAGER_ID);
        dispatch({ type: OPT_IN });
    };

    const optOut = () => {
        setConsent({ decision: true, marketing: false });
        dispatch({ type: OPT_OUT });
    };

    const openSettings = () => {
        dispatch({ type: OPEN_SETTINGS });
    };

    const closeSettings = () => {
        dispatch({ type: CLOSE_SETTINGS });
    };

    return (
        <ConsentContext.Provider
            value={{
                decision: state.decision,
                marketing: state.marketing,
                showBanner: state.showBanner,
                hydrated: state.hydrated,
                optIn,
                optOut,
                openSettings,
                closeSettings
            }}
        >
            {children}
        </ConsentContext.Provider>
    );
};

export const useConsentContext = () => {
    const context = useContext(ConsentContext);

    if (context === undefined) {
        throw new Error(
            'useConsentContext must be used within a ConsentProvider'
        );
    }

    return context;
};
